// COOKIE

function getBannerEl() {
    return document.getElementById('cookies-bar');
  }

  function hideBanner(res) {
    getBannerEl().style.display = 'none';
    localStorage.removeItem('cookies');
  }

  function showBanner() {
   getBannerEl().style.display = 'block';
  }

  function handleAccept(e) {
    window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);

    document.addEventListener('trackingConsentAccepted',function() {
      console.log('trackingConsentAccepted event fired');
    });
  }

  function handleDecline() {
    window.Shopify.customerPrivacy.setTrackingConsent(false,hideBanner);
  }

  function initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

    if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
      showBanner();
    }
  }

  window.Shopify.loadFeatures([
    {
      name: 'consent-tracking-api',
      version: '0.1',
    }
  ],
  function(error) {
    if (error) {
      throw error;
    }
    console.log(localStorage);
    const cookiesValue = localStorage.getItem('cookies');
    if (cookiesValue !== null) {
      showBanner();
    }
  
    initCookieBanner();
  });

  
  // Cookies after submit orbe form

  const cookieRequirementCountries = [
    "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR",
    "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
    "PL", "PT", "RO", "SK", "SI", "ES", "SE","GB", "CA", "AU",
    "NO", "SE", "SZ"
  ];

  document.addEventListener('DOMContentLoaded', function() {
    const orbeCountryList = document.getElementById("orbeCountryList");
    const countryNames = orbeCountryList.querySelectorAll('[data-country]');
    countryNames.forEach((country) => {
        country.addEventListener('click', (event) => {
            const clickedElement = event.currentTarget; 
            const countryValue = clickedElement.getAttribute('data-country'); 
            if (cookieRequirementCountries.includes(countryValue)) {
                localStorage.setItem('cookies', 'show');
            } else {
                localStorage.removeItem('cookies');
            }
        });
    });
  });